import React, { useState } from "react";
import ReactTable from "react-table";
import { templateStatus } from "./TemplatesModel";
import { formatUTCtoPST } from "../../shared/utility";
import Button from "../../components/CustomButtons/Button";
import { Checkbox, FormControlLabel, IconButton } from "@material-ui/core";
import Notification from "../../components/Notification/Notification";
import NotificationAsk from "../../components/Notification/NotificationAsk";

const TemplatesList = (props) => {
    const [ask, setAsk] = useState(null);
    const { templates, open, type, setDefault } = props;
    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "id",
                  desc: true,
              },
          ];

    return (
        <div className="react-table-hover-gray">
            <ReactTable
                defaultSorted={defaultSorted}
                data={templates.map(d => {
                    return {
                        id: d.id,
                        date_created:  formatUTCtoPST(d.date_created),
                        date_modified: formatUTCtoPST(d.date_modified),
                        status: templateStatus[d.status],
                        title: d.title,
                        name: d.name,
                        default: <div className="grayscaled">
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={props.default == d.id ? true : false}
                                    onChange={() => {
                                        setDefault(d.id);
                                    }}
                                    color="primary"
                                />
                                }
                                label="Default"
                            />
                        </div>,
                        action: <>
                            <IconButton
                                onClick={() => {
                                    open(d);
                                }}
                            >
                                <i className="fa fa-edit"></i>
                            </IconButton>
                            {props.default != d.id && <IconButton
                                onClick={() => {
                                    setAsk(d.id);
                                }}
                            >
                                <i className="fa fa-trash"></i>
                            </IconButton>}
                        </>
                    }
                })}
                className="-striped"
                showPaginationTop
                showPaginationBottom
                columns={[
                {
                    Header: "ID #",
                    accessor: "id" 
                },
                {
                    Header: "Date Created",
                    accessor: "date_created"
                },
                {
                    Header: "Date Modified",
                    accessor: "date_modified"
                },
                {
                    Header: "Submitter",
                    accessor: "name"
                },
                {
                    Header: "Title",
                    accessor: "title"
                },
                {
                    Header: "Status",
                    accessor: "status"
                },
                {
                    Header: "Default",
                    accessor: "default"
                },
                {
                    Header: "Action",
                    accessor: "action"
                },
            ]}
                resizable
                defaultPageSize={10}
                pageSizeOptions={[10, 20, 30]}
                minRows={10}
                filterable
            />

            {ask && <NotificationAsk
                open={true}
                close={() => {
                    setAsk('');
                }}
                title="Are you sure?"
                message="Do you want to delete this template?"
                success={() => {
                    props.delete(ask);
                    setAsk('');
                }}
            />}
        </div>
    );
};

export default TemplatesList;
